import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "body"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_8 = {
  key: 1,
  class: "mb-3",
  style: {"color":"#b00020"}
}
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = {
  key: 2,
  style: {"max-height":"50vh","overflow-y":"auto"}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  key: 4,
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Import errors",
          text: "Import errors"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    (_ctx.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.detail.fileName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(_ctx.detail.fileName), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.detail.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.detail.errorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              localizedKey: "Rows with errors",
              text: "Rows with errors"
            }),
            _createTextVNode(": "),
            _createElementVNode("b", null, _toDisplayString(_ctx.detail.errorCount), 1)
          ]),
          (_ctx.detail.errors && _ctx.detail.errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.errors, (e, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    innerHTML: e
                  }, null, 8, _hoisted_11))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No row errors to show",
                  text: "No row errors to show"
                })
              ])),
          (_ctx.detail.errorCount > _ctx.detail.errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Showing first",
                  text: "Showing first"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.detail.errors.length) + " / " + _toDisplayString(_ctx.detail.errorCount), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}